import { provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { HybridService } from '@core/hybrid/hybrid.service';
import { IconSpriteService } from '@core/services/icon-sprite.service';
import { handleViewTransition } from '@core/view-transition.helper';
import { provideTranslateService } from '@ngx-translate/core';

import { provideGuidedTourPorts, provideTour } from '@features/guided-tour/guided-tour.providers';
import { TOOLBAR_OVERVIEW_TOUR } from '@features/guided-tour/tours/toolbar-overview.tour';

import { routes } from './app.routes';
import { createApolloProvider } from './core/graphql';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZonelessChangeDetection(),
        provideRouter(routes, withViewTransitions({ onViewTransitionCreated: handleViewTransition })),
        provideTranslateService({
            fallbackLang: 'en',
            lang: 'en'
        }),

        provideHttpClient(withFetch()),
        createApolloProvider(),
        provideAppInitializer(() => {
            const hybridService = inject(HybridService);

            if (hybridService.isHybridApp()) {
                hybridService.start();
            }

            inject(IconSpriteService).loadIconSprite();
        }),

        // Tour registrations — TourRegistry consumes these via multi-provider.
        provideTour(TOOLBAR_OVERVIEW_TOUR),

        // Default port implementations for the tour engine. Replace providers above
        // `TourEngine`'s first instantiation to swap in alternative implementations.
        provideGuidedTourPorts(),
    ]
};
